import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import "./BillsFilter.css";
import jsPDF from "jspdf";
import "jspdf-autotable";

function TicketCaisse({ currentUser }) {
  const [bills, setBills] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
const [locations, setLocations] = useState([]);



 useEffect(() => {
  const loadLocations = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get("/api/Locations/getAllLocations", {
        headers: { Authorised: token }
      });

      setLocations(res.data);
    } catch (err) {
      console.log("Erreur getAllLocations :", err);
    }
  };

  loadLocations();
}, []);



  // 🔍 Fonction pour extraire l'ID de localisation quelle que soit sa forme
const extractLocId = (loc) => {
  if (!loc) return null;

  // Cas string direct
  if (typeof loc === "string") return loc;

  // Cas {_id: "..."}
  if (typeof loc._id === "string") return loc._id;

  // Cas {"$oid": "..."}
  if (typeof loc.$oid === "string") return loc.$oid;

  // Cas {_id: {"$oid": "..."}}
  if (loc._id && typeof loc._id.$oid === "string") return loc._id.$oid;

  // Cas MongoDB Object → try toString()
  if (loc.toString) return loc.toString();

  return null;
};


  const getProductDetails = useCallback(
    (item) => {
      console.log("🔹 getProductDetails appelé pour item :", item);

      // 🔹 Vérifier si c'est un produit principal
      const mainProduct = products.find((p) => p._id === item.id);
      if (mainProduct) {
        console.log("✅ Produit principal trouvé :", mainProduct.name);
        return {
          parent: mainProduct.name,
          name: null,
          price: item.price || mainProduct.price,
          localisation: extractLocId(mainProduct.localisation),
          hasSubProduct: false
        };
      }

      // 🔹 Vérifier si c'est un sous-produit
      for (const product of products) {
        const subProduct = product.subProductsV?.find((sp) => sp._id === item.id);
        if (subProduct) {
          console.log("✅ Sous-produit trouvé :", subProduct.name, "du produit :", product.name);
          return {
            parent: product.name,
            name: subProduct.name,
            price: item.price || subProduct.price,
            localisation: extractLocId(subProduct.localisation),
            hasSubProduct: true
          };
        }
      }

      // 🔹 Si inconnu
      console.warn("⚠️ Produit inconnu :", item);
      return {
        name: item.name || "Produit inconnu",
        parent: null,
        price: item.price || 0,
        localisation: null,
        hasSubProduct: false
      };
    },
    [products]
  );

  const fetchAllData = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      console.log("📡 Fetching data avec token :", token);

      const [productsRes, billsRes] = await Promise.all([
        axios.get("/api/ProductV/getProductV", { headers: { Authorised: token } }),
        axios.get("/api/BillsValises/getAllBillsV", { headers: { Authorised: token } }),
      ]);

      console.log("📦 Produits reçus :", productsRes.data);
      console.log("🧾 Factures reçues :", billsRes.data);

      setProducts(productsRes.data || []);
      setBills(billsRes.data || []);
    } catch (err) {
      console.error("❌ Erreur chargement données :", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  const now = new Date();
  const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
  const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);

  // 🔹 Extraire correctement la localisation utilisateur
  const userLocId = extractLocId(currentUser?.localisation);
  console.log("📍 Localisation utilisateur pour filtrage :", userLocId);

  // 🔹 CORRIGÉ : Filtrer les factures du jour selon la localisation de l'UTILISATEUR
  const dailyBills = bills.filter((bill) => {
    const billDate = new Date(bill.date);
    if (billDate < startOfDay || billDate > endOfDay) return false;

    // 🔹 CORRECTION PRINCIPALE : Utiliser la localisation de la FACTURE ou de l'UTILISATEUR qui a créé la facture
    if (currentUser?.role === "admin") return true;
    if (!userLocId) return true;

    // 🔹 OPTION 1 : Si la facture a une localisation directe
    const billLocId = extractLocId(bill.localisation);
    if (billLocId && billLocId === userLocId) return true;

    // 🔹 OPTION 2 : Si l'utilisateur qui a créé la facture a la même localisation
    const billUserLocId = extractLocId(bill.user?.localisation);
    if (billUserLocId && billUserLocId === userLocId) return true;

    // 🔹 OPTION 3 : Si currentUser est l'utilisateur qui a créé la facture
    if (bill.user?._id === currentUser?._id) return true;

    return false;
  });

  console.log("🧾 Factures filtrées par localisation utilisateur :", dailyBills);

  // 🔹 Séparer les ventes actives et les annulations
  const activeItems = [];
  const cancelledItems = [];

  dailyBills.forEach((bill) => {
    bill.items.forEach((item) => {
      const details = getProductDetails(item);
      
      // 🔹 Ne garder que les items qui ont un sous-produit
      if (details.hasSubProduct) {
        const itemData = {
          bill,
          item,
          details,
          isCancelled: item.isCancelled || false,
          cancelReason: item.cancelReason || "",
          cancelledAt: item.cancelledAt || null
        };

        if (item.isCancelled) {
          cancelledItems.push(itemData);
        } else {
          activeItems.push(itemData);
        }
      }
    });
  });

  console.log("🟢 Ventes actives :", activeItems);
  console.log("🔴 Articles annulés :", cancelledItems);

  // 🔹 Calcul des totaux
  const totalActiveAmount = activeItems.reduce((sum, { item, details }) => {
    return sum + (details.price || 0) * (item.quantity || 1);
  }, 0);

  const totalCancelledAmount = cancelledItems.reduce((sum, { item, details }) => {
    return sum + (details.price || 0) * (item.quantity || 1);
  }, 0);

  const netAmount = totalActiveAmount - totalCancelledAmount;



  // 🔹 Fonction pour générer le PDF
    const generatePDF = () => {

      const userLocId = extractLocId(currentUser?.localisation);

const userLocationName =
  locations.find((loc) => extractLocId(loc._id) === userLocId)?.name ||
  "Non définie";


    const doc = new jsPDF();
    

    // En-tête du rapport
    doc.setFontSize(20);
    doc.setTextColor(40, 40, 40);
    doc.text("RAPPORT DE CAISSE", 105, 15, { align: "center" });
    
    doc.setFontSize(12);
    doc.setTextColor(100, 100, 100);
    doc.text(`Date: ${new Date().toLocaleDateString("fr-FR")}`, 105, 25, { align: "center" });
    doc.text(`Localisation: ${userLocationName}`, 105, 32, {
  align: "center",
});

    doc.text(`Généré par: ${currentUser?.name || "Utilisateur"}`, 105, 39, { align: "center" });

    let yPosition = 50;

    // 🔹 Section VENTES ACTIVES
    doc.setFontSize(16);
    doc.setTextColor(0, 100, 0);
    doc.text("VENTES ACTIVES", 14, yPosition);
    yPosition += 10;

    if (activeItems.length > 0) {
      const activeTableData = activeItems.map(({ bill, item, details }, index) => [
        index + 1,
        new Date(bill.date).toLocaleTimeString("fr-FR"),
        details.parent || "-",
        details.name || "-",
        item.quantity,
        `${(details.price || 0).toFixed(2)} DT`,
        bill.paymentMethod,
        bill.billNumber
      ]);

      doc.autoTable({
        startY: yPosition,
        head: [['#', 'Heure', 'Produit', 'Sous-produit', 'Qte', 'Prix', 'Paiement', 'Facture']],
        body: activeTableData,
        theme: 'grid',
        headStyles: { fillColor: [0, 100, 0] },
        margin: { top: 10 }
      });

      yPosition = doc.lastAutoTable.finalY + 10;
    } else {
      doc.setFontSize(10);
      doc.setTextColor(150, 150, 150);
      doc.text("Aucune vente active aujourd'hui", 14, yPosition);
      yPosition += 15;
    }

    // 🔹 Section ARTICLES ANNULÉS
    doc.setFontSize(16);
    doc.setTextColor(200, 0, 0);
    doc.text("ARTICLES ANNULÉS", 14, yPosition);
    yPosition += 10;

    if (cancelledItems.length > 0) {
      const cancelledTableData = cancelledItems.map(({ bill, item, details }, index) => [
        index + 1,
        new Date(bill.date).toLocaleTimeString("fr-FR"),
        details.parent || "-",
        details.name || "-",
        item.quantity,
        `${(details.price || 0).toFixed(2)} DT`,
        item.cancelReason || "Non spécifié",
        new Date(item.cancelledAt).toLocaleTimeString("fr-FR") || "-"
      ]);

      doc.autoTable({
        startY: yPosition,
        head: [['#', 'Heure vente', 'Produit', 'Sous-produit', 'Qte', 'Prix', 'Motif', 'Heure annulation']],
        body: cancelledTableData,
        theme: 'grid',
        headStyles: { fillColor: [200, 0, 0] },
        margin: { top: 10 }
      });

      yPosition = doc.lastAutoTable.finalY + 10;
    } else {
      doc.setFontSize(10);
      doc.setTextColor(150, 150, 150);
      doc.text("Aucun article annulé aujourd'hui", 14, yPosition);
      yPosition += 15;
    }

    // 🔹 Section RÉCAPITULATIF
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text("RÉCAPITULATIF FINANCIER", 105, yPosition + 10, { align: "center" });
    
    doc.setFontSize(12);
    doc.setTextColor(0, 100, 0);
    doc.text(`Total ventes actives: ${totalActiveAmount.toFixed(2)} DT`, 14, yPosition + 25);
    
    doc.setTextColor(200, 0, 0);
    doc.text(`Total annulations: ${totalCancelledAmount.toFixed(2)} DT`, 14, yPosition + 35);
    
    doc.setFontSize(13);
    doc.setTextColor(0, 0, 150);
    doc.text(`NET À ENCAISSER: ${netAmount.toFixed(2)} DT`, 14, yPosition + 50);

    // 🔹 Statistiques
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Nombre de ventes: ${activeItems.length}`, 14, yPosition + 65);
    doc.text(`Nombre d'annulations: ${cancelledItems.length}`, 14, yPosition + 72);
    doc.text(`Taux d'annulation: ${dailyBills.length > 0 ? ((cancelledItems.length / (activeItems.length + cancelledItems.length)) * 100).toFixed(1) : 0}%`, 14, yPosition + 79);

    // Pied de page
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(`Rapport généré le ${new Date().toLocaleString("fr-FR")}`, 105, 280, { align: "center" });

    // Sauvegarder le PDF
    doc.save(`rapport-caisse-${new Date().toLocaleDateString("fr-FR")}.pdf`);
  };

  return (
    <div className="bills-filter">
      <div className="report-header">
        <h2>🧾 Rapport de Caisse du Jour</h2>
        <button onClick={generatePDF} className="pdf-button">
          📄 Exporter PDF
        </button>
      </div>

      <p>
        📅{" "}
        {new Date().toLocaleDateString("fr-FR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </p>

      {/* 🔹 Récapitulatif rapide */}
      <div className="summary-cards">
        <div className="summary-card active">
          <h3>Ventes Actives</h3>
          <p className="amount">{totalActiveAmount.toFixed(2)} DT</p>
          <p className="count">{activeItems.length} articles</p>
        </div>
        <div className="summary-card cancelled">
          <h3>Annulations</h3>
          <p className="amount">{totalCancelledAmount.toFixed(2)} DT</p>
          <p className="count">{cancelledItems.length} articles</p>
        </div>
        <div className="summary-card net">
          <h3>Net à encaisser</h3>
          <p className="amount">{netAmount.toFixed(2)} DT</p>
        </div>
      </div>

      {loading ? (
        <p>Chargement...</p>
      ) : (
        <>
          {/* 🔹 Section VENTES ACTIVES */}
          <div className="section active-sales">
            <h3 className="section-title">🟢 Ventes Actives</h3>
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Heure</th>
                  <th>Produit</th>
                  <th>Sous-produit</th>
                  <th>Quantité</th>
                  <th>Prix unitaire</th>
                  <th>Paiement</th>
                  <th>Facture</th>
                </tr>
              </thead>
              <tbody>
                {activeItems.length > 0 ? (
                  activeItems.map(({ bill, item, details }, idx) => (
                    <tr key={`active-${bill._id}-${idx}`}>
                      <td>{idx + 1}</td>
                      <td>{new Date(bill.date).toLocaleTimeString("fr-FR")}</td>
                      <td>{details.parent}</td>
                      <td>{details.name}</td>
                      <td>{item.quantity}</td>
                      <td>{(details.price || 0).toFixed(2)} DT</td>
                      <td>{bill.paymentMethod}</td>
                      <td>#{bill.billNumber}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center", color: "gray" }}>
                      Aucune vente active aujourd'hui.
                    </td>
                  </tr>
                )}
                {activeItems.length > 0 && (
                  <tr className="total-row">
                    <td colSpan="5" style={{ fontWeight: "bold", textAlign: "right" }}>
                      Total ventes actives :
                    </td>
                    <td style={{ fontWeight: "bold" }}>{totalActiveAmount.toFixed(2)} DT</td>
                    <td colSpan="2"></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 🔹 Section ANNULATIONS */}
          <div className="section cancelled-sales">
            <h3 className="section-title">🔴 Articles Annulés</h3>
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Heure vente</th>
                  <th>Produit</th>
                  <th>Sous-produit</th>
                  <th>Quantité</th>
                  <th>Prix unitaire</th>
                  <th>Motif</th>
                  <th>Annulé à</th>
                </tr>
              </thead>
              <tbody>
                {cancelledItems.length > 0 ? (
                  cancelledItems.map(({ bill, item, details }, idx) => (
                    <tr key={`cancelled-${bill._id}-${idx}`} className="cancelled-row">
                      <td>{idx + 1}</td>
                      <td>{new Date(bill.date).toLocaleTimeString("fr-FR")}</td>
                      <td>{details.parent}</td>
                      <td>{details.name}</td>
                      <td>{item.quantity}</td>
                      <td>{(details.price || 0).toFixed(2)} DT</td>
                      <td>
                        <span className="cancel-reason">{item.cancelReason}</span>
                      </td>
                      <td>
                        {item.cancelledAt 
                          ? new Date(item.cancelledAt).toLocaleTimeString("fr-FR")
                          : "-"
                        }
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center", color: "gray" }}>
                      Aucun article annulé aujourd'hui.
                    </td>
                  </tr>
                )}
                {cancelledItems.length > 0 && (
                  <tr className="total-row cancelled-total">
                    <td colSpan="5" style={{ fontWeight: "bold", textAlign: "right" }}>
                      Total annulations :
                    </td>
                    <td style={{ fontWeight: "bold" }}>{totalCancelledAmount.toFixed(2)} DT</td>
                    <td colSpan="2"></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

export default TicketCaisse;